import { render, staticRenderFns } from "./MoneyRecord.vue?vue&type=template&id=ecb7dd32&scoped=true&"
import script from "./MoneyRecord.vue?vue&type=script&lang=js&"
export * from "./MoneyRecord.vue?vue&type=script&lang=js&"
import style0 from "./MoneyRecord.vue?vue&type=style&index=0&id=ecb7dd32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb7dd32",
  null
  
)

export default component.exports